import CTAButton from '../CTAButton';

const OutcomeMetrics = ({ outcomes, title, onCtaClick }) => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <div className=" mx-auto text-center mb-16">
                    {title ? (
                        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4 syne">{title}</h2>
                    ) : (
                        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4 syne">Measurable Hiring <span className="text-blue-600">Outcomes</span></h2>
                    )}
                    <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                        Key performance metrics and results achieved through our strategic workforce solutions.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {outcomes.map((item, i) => (
                        <div key={i} className="bg-blue-50/20 p-6 rounded-xl shadow-sm border-x border-b border-t-2 border-l-2  border-x-blue-100/50 border-b-blue-100/50 border-t-blue-600 hover:shadow-xl transition-all text-center">
                            <div className="text-blue-600 font-black text-xl mb-4">{(i + 1).toString().padStart(2, '0')}</div>
                            <h4 className="text-lg font-bold text-slate-900 mb-4">{typeof item === 'string' ? item : item.title}</h4>
                            {typeof item === 'object' && item.description && (
                                <p className="text-sm text-slate-500 leading-relaxed">{item.description}</p>
                            )}
                        </div>
                    ))}
                </div>
                {onCtaClick && (
                    <div className="mt-16 text-center flex justify-center">
                        <CTAButton text="Achieve These Outcomes" onClick={onCtaClick} />
                    </div>
                )}
            </div>
        </section>
    );
};
export default OutcomeMetrics